exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".health-check .status-code {\n  display: inline-block;\n  margin: 4px;\n  margin-top: 5px;\n  border: 1px solid var(--color-dovegray);\n  border-radius: 6px;\n  padding-left: 4px;\n  padding-right: 4px;\n  background-color: var(--color-alto);\n}\n.health-check .status-code span.glyphicon {\n  margin-top: 2px;\n  vertical-align: top;\n  margin-left: 3px;\n  font-weight: bold;\n  cursor: pointer;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./app/scripts/modules/openstack/src/loadBalancer/loadBalancer.less
// module id = 3739
// module chunks = 0